import React from "react";
import type { RouteProps } from "react-router-dom";
import { Redirect, Route } from "react-router-dom";

import { authenticationManager } from "../../../../shared/core/service/services";
import { useObservable } from "../../../../shared/utils/observable";
import { PageWithNav } from "../../../ui/common/page/page-with-nav";
import { Path, SAVING_BASE_PATH, TRANSFER_BASE_PATH } from "../path";

/** Screens that open with a title of their own, so the greeting band would double up. */
const PATHS_WITH_OWN_TITLE: string[] = [
  Path.MyAccount,
  Path.AccountStatements,
  Path.FeesStatements,
  Path.Cards,
  Path.AllCards,
  Path.AllTransactions,
  Path.ProfileMenu,
];

export const AuthNavRoute = (props: RouteProps) => {
  const isConnected = useObservable(authenticationManager.isConnected);
  const { path } = props;

  const isPathIncluded = (path: string) => {
    const basePaths = [TRANSFER_BASE_PATH, SAVING_BASE_PATH];

    return basePaths.some((basePath) => path.includes(basePath));
  };

  return isConnected ? (
    <PageWithNav
      withTitle={
        isPathIncluded(path as string)
          ? false
          : path !== Path.JustifyTransaction && !PATHS_WITH_OWN_TITLE.includes(path as string)
      }
    >
      <Route {...props} />
    </PageWithNav>
  ) : (
    <Redirect to={{ pathname: Path.Root }} />
  );
};
